/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ closeDateLine: NonNullable<unknown> }} Coinvestments_Report_Stillactive_Description2Inputs */

const en_coinvestments_report_stillactive_description2 = /** @type {(inputs: Coinvestments_Report_Stillactive_Description2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In order to generate the report the deal must be closed.${i?.closeDateLine}`)
};

/**
* | output |
* | --- |
* | "In order to generate the report the deal must be closed.{closeDateLine}" |
*
* @param {Coinvestments_Report_Stillactive_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_stillactive_description2 = /** @type {((inputs: Coinvestments_Report_Stillactive_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Stillactive_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_stillactive_description2(inputs)
});
export { coinvestments_report_stillactive_description2 as "coInvestments_report_stillActive_description" }